import React from 'react';
import {Referral, ScopeOfServiceRenderer, ServiceTypeRenderer} from 'referral';
import {ConsiderationRenderer} from './ConsiderationRenderer';
import {ReferralHoursRenderer} from './ReferralHoursRenderer';
import {ScheduleNotesRenderer} from './ScheduleNotesRenderer';
import {SiblingDetails} from './siblings/SiblingDetails';
import {ServiceLocationRenderer} from "./ServiceLocationRenderer";


type ReferralDetailProps = {
    referral: Referral;
}

export const ReferralDetail = ({referral}: ReferralDetailProps) => {
    return (
        <>
            <div className='pb-5'>
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Referral ID
                    </div>
                    <div className='w-1/2'>
                        {referral.caseNumber || 'None'}
                    </div>
                </div>
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Client Name
                    </div>
                    <div className='w-1/2'>
                        {referral?.clientName ? referral.clientName : 'None'}
                    </div>
                </div>
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Service Type
                    </div>
                    <div className='w-1/2'>
                        <ServiceTypeRenderer referral={referral} textEllipsis={false}/>
                    </div>
                </div>
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Scope of Services
                    </div>
                    <div className='w-1/2'>
                        <ScopeOfServiceRenderer referral={referral} textEllipsis={false}/>
                    </div>
                </div>
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Location
                    </div>
                    <div className='w-1/2'>
                        {referral.location || 'None'}
                    </div>
                </div>
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Age
                    </div>
                    <div className='w-1/2'>
                        {referral.clientAge || 'None'}
                    </div>
                </div>
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Required Language
                    </div>
                    <div className='w-1/2'>
                        {referral.requiredLanguage || 'None'}
                    </div>
                </div>

                <SiblingDetails referral={referral}/>
            </div>

            <ReferralHoursRenderer referral={referral}/>

            {
                referral?.serviceLocations && referral.serviceLocations.length > 0 &&
                <div className='pb-5'>
                    <div className='font-semibold pb-2'>
                        Service Location
                    </div>
                    <div className="pb-2">
                        <ServiceLocationRenderer fieldName={'serviceLocations'} referral={referral}/>
                    </div>
                </div>
            }
            {
                referral?.serviceLocationsParaprofessional && referral.serviceLocationsParaprofessional.length > 0 &&
                <div className='pb-5'>
                    <div className='font-semibold pb-2'>
                        Service Location Paraprofessional
                    </div>
                    <div className="pb-2">
                        <ServiceLocationRenderer fieldName={'serviceLocationsParaprofessional'} referral={referral}/>
                    </div>
                </div>
            }
            {
                referral?.serviceLocationsMidLevel && referral.serviceLocationsMidLevel.length > 0 &&
                <div className='pb-5'>
                    <div className='font-semibold pb-2'>
                        Service Location Mid-Level
                    </div>
                    <div className="pb-2">
                        <ServiceLocationRenderer fieldName={'serviceLocationsMidLevel'} referral={referral}/>
                    </div>
                </div>
            }
            {
                referral?.serviceLocationsHighLevel && referral.serviceLocationsHighLevel.length > 0 &&
                <div className='pb-5'>
                    <div className='font-semibold pb-2'>
                        Service Location High-Level
                    </div>
                    <div className="pb-2">
                        <ServiceLocationRenderer fieldName={'serviceLocationsHighLevel'} referral={referral}/>
                    </div>
                </div>
            }
            {
                referral?.serviceLocationsGroupCare && referral.serviceLocationsGroupCare.length > 0 &&
                <div className='pb-5'>
                    <div className='font-semibold pb-2'>
                        Service Location Group Care
                    </div>
                    <div className="pb-2">
                        <ServiceLocationRenderer fieldName={'serviceLocationsGroupCare'} referral={referral}/>
                    </div>
                </div>
            }

            <div className='pb-5'>
                <div className='font-semibold pb-5'>
                    Schedule Notes
                </div>
                <div className='pb-2'>
                    <ScheduleNotesRenderer referral={referral}/>
                </div>
            </div>
            <div className='pb-5'>
                <div className='font-semibold pb-5'>
                    Treatment Considerations
                </div>
                <div className="pb-2">
                    <ConsiderationRenderer referral={referral}/>
                </div>
            </div>
        </>
    );

};
